function showWachtwoordVergeten()
{
    $.fancybox.showLoading();
    $.ajax({
        type: 'post',
        url: window.location,
        type: 'post',
        data: {action:'showComponent',module:'webshop','args[naam]':'WachtwoordVergeten'},
        success: function(data)
        {
            $.fancybox(data);           
        }
    });
}

function submitWachtwoordVergeten(form)
{
    $.fancybox.showLoading();
    $.ajax({
        url: 'webshop/wachtwoord-vergeten/',
        type: 'post',
        dataType: 'json',
        data: form.serialize(),
        success: function(data)
        {
            $.fancybox(data.content);
            
            /*
            if (data === '1')
            {
                $.fancybox.close();
            }
            else
            {
                $.fancybox(data);                
            }
            */
        }
    });
}